var module = angular.module('octopusApp.projects');

module.directive('releaseDefects', function(busy, octopusRepository, octoDialog) {
  return {
    restrict: 'E',
    replace: true,
    transclude: false,
    templateUrl: 'areas/projects/views/release_defects.html',
    scope: {
      release: '=',
      progression: '='
    },
    link: function(scope, element) {

      var isLoading = scope.isDefectLoading = busy.create();
      var isSaving = scope.isDefectSaving = busy.create();

      var defects = scope.defects = {
        releaseHasDefect: false,
        showReportArea: false,
        defectDescription: null,
        newDefectDescription: null,
        toggleReportArea: function(){
          this.showReportArea = !this.showReportArea;
        },
        reportDefect: function() {
          var me = this;
          isSaving.promise(octopusRepository.Defects.report(scope.release, me.newDefectDescription).then(function () {
            me.releaseHasDefect = true;
            me.defectDescription = me.newDefectDescription;

            me.showReportArea = false;
            me.newDefectDescription = null;
            scope.$emit('progress-updates', null);
          }));
        },
        resolveDefect: function() {
          var me = this;
          octoDialog.asyncConfirm({
            title: "Unblock deployment",
            message: "If it is now safe to proceed with deployments of this release, you can unblock it.",
            executeButtonClass: "btn-success",
            executeButtonText: "Unblock",
            windowClass: "modal-alert modal-info fade",

            execute: function (dialog) {
              isSaving.promise(octopusRepository.Defects.resolve(scope.release).then(function () {
                me.releaseHasDefect = false;
                scope.$emit('progress-updates', null);
                dialog.dismiss();
              }));
            }
          });
        }
      };

      scope.$watch("release", function() {
        if (!scope.release) {
          return;
        }

        isLoading.promise(octopusRepository.Defects.all(scope.release).then(function (defectList) {

          var defect = null;
          var hasItems = defectList.Items.length > 0;
          if (hasItems) {
            var lastIndex = defectList.Items.length - 1;
            var potentialDefect = defectList.Items[lastIndex];
            if (potentialDefect.Status === 'Unresolved') {
              defect = potentialDefect;
            }
          }

          defects.releaseHasDefect = (defect !== null);

          if(defect) {
            defects.defectDescription = defect.Description;
          }
        }));

      });
      //

    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/directives/release_defects.js
// module id = 552
// module chunks = 1